import type { ReactNode } from "react";
import { useTranslations } from "use-intl";

import { Link } from "@/components/link";
import type { ClientNotificationItem } from "@garimpa/api/notifications/toClientNotification";

export function notificationActorDisplayLabel(
  actor: ClientNotificationItem["actor"],
  someone: string,
): string {
  if (!actor) return someone;
  return actor.displayName ?? actor.name ?? actor.username ?? someone;
}

export function NotificationMainLine({ notification }: { notification: ClientNotificationItem }) {
  const t = useTranslations("globals.notifications");
  const name = notificationActorDisplayLabel(notification.actor, t("someone"));
  const userlink = (chunks: ReactNode) => {
    const isCommentNotification = notification.type === "feed_event_comment";
    if (
      isCommentNotification ||
      notification.primaryHref ||
      !notification.actor?.username ||
      notification.actor.isGuest
    ) {
      return <span className="font-medium">{chunks}</span>;
    }
    return (
      <Link
        to={`/u/${notification.actor.username}`}
        className="font-medium text-foreground underline-offset-2 hover:underline"
        onClick={(event) => event.stopPropagation()}
      >
        {chunks}
      </Link>
    );
  };
  const values = { userlink, name };

  const richKeys: Record<string, "newFollower" | "postLiked" | "postCommented"> = {
    new_follower: "newFollower",
    post_like: "postLiked",
    feed_event_comment: "postCommented",
  };
  if (notification.type === "deal_price_drop") {
    return notification.subject.title ?? t("dealPriceDrop");
  }
  const richKey = richKeys[notification.type];
  if (richKey) return t.rich(richKey, values);
  return t("genericNotification");
}
